'use strict';

import { Fancybox } from "@fancyapps/ui";
/**
 *  Load modules
 */
import header from './modules/header.js';
import sliders from './modules/sliders.js';
import '../scss/app.scss';
$(document).ready(function () {
  header();
  sliders();
  Fancybox.bind("[data-fancybox]", {});
});

//counters
var $findme = $('.counter__items');
var exec = false;
function Scrolled() {
  $findme.each(function () {
    var $section = $(this),
      findmeOffset = $section.offset(),
      findmeTop = findmeOffset.top,
      findmeBottom = $section.height() + findmeTop,
      scrollTop = $(document).scrollTop(),
      visibleBottom = window.innerHeight,
      prevVisible = $section.prop('_visible'),
      visible = true;
    if (findmeTop > scrollTop + visibleBottom || findmeBottom < scrollTop) {
      visible = false;
    }
    if (!prevVisible && visible) {
      if (!exec) {
        $('.counter-item span').each(function () {
          $(this).prop('Counter', 0).animate({
            Counter: $(this).text()
          }, {
            duration: 1000,
            step: function step(now) {
              $(this).text(Math.ceil(now));
              exec = true;
            }
          });
        });
      }
    }
    $section.prop('_visible', visible);
  });
}
$(document).ready(function () {
  Scrolled();
  $(window).scroll(function () {
    Scrolled();
  });
});